// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"7a7c588b","65":"973153df","67":"ddf99f33","88":"cec164fb","123":"a9519a36","589":"367b6b58","605":"27566ab0","648":"8a13320e","661":"d6333420","671":"1a8e83e3","808":"426ad836","936":"05f4e637"}[chunkId] + ".chunk.js";
};